export function isStaffUser(user?: { role?: string } | null): boolean {
  return user?.role === 'STAFF_USER';
}

export function isStaffUserPathAllowed(pathname: string): boolean {
  if (pathname === '/' || pathname === '/profile' || pathname === '/user/profile') return true;
  if (pathname === '/m-photo-pro' || pathname === '/m-photo-lite' || pathname === '/m-photo-mono') {
    return true;
  }
  if (pathname === '/mobile-upload' || pathname.startsWith('/mobile-upload/')) return true;
  return false;
}
